import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "book-contents-browser list-page-body" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "list-page-sidebar-inner" }
const _hoisted_4 = { class: "list-sidebar-section" }
const _hoisted_5 = { class: "list-sidebar-title" }
const _hoisted_6 = { class: "book-toolbar" }
const _hoisted_7 = { class: "book-toolbar-inner" }
const _hoisted_8 = { class: "search-box" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "list-sidebar-section"
}
const _hoisted_11 = { class: "list-sidebar-title" }
const _hoisted_12 = { class: "book-filters-row" }
const _hoisted_13 = { class: "list-sidebar-section" }
const _hoisted_14 = { class: "list-sidebar-title" }
const _hoisted_15 = { class: "view-toggle" }
const _hoisted_16 = ["data-bs-title"]
const _hoisted_17 = ["data-bs-title"]
const _hoisted_18 = { class: "list-sidebar-section" }
const _hoisted_19 = { class: "list-sidebar-title" }
const _hoisted_20 = { class: "alphabet-nav alphabet-nav--vertical" }
const _hoisted_21 = ["href", "onClick"]
const _hoisted_22 = {
  key: 1,
  class: "alphabet-link disabled"
}
const _hoisted_23 = { class: "list-page-main" }
const _hoisted_24 = { class: "book-contents-wrapper" }
const _hoisted_25 = ["id", "data-letter"]
const _hoisted_26 = { class: "letter-heading" }
const _hoisted_27 = { class: "items-container" }
const _hoisted_28 = ["href", "data-content-window-id", "data-content-window-title", "onClick"]
const _hoisted_29 = { class: "item-icon" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "item-content" }
const _hoisted_33 = { class: "item-name" }
const _hoisted_34 = {
  key: 0,
  class: "item-description"
}
const _hoisted_35 = { class: "item-type-badge" }
const _hoisted_36 = {
  key: 0,
  class: "bi bi-star-fill favorite-indicator"
}
const _hoisted_37 = ["id", "data-letter"]
const _hoisted_38 = { class: "letter-heading" }
const _hoisted_39 = { class: "cards-grid" }
const _hoisted_40 = ["href", "data-content-window-id", "data-content-window-title", "onClick"]
const _hoisted_41 = {
  key: 0,
  class: "card-image"
}
const _hoisted_42 = ["src", "alt"]
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = { class: "card-body" }
const _hoisted_45 = { class: "card-title" }
const _hoisted_46 = {
  key: 0,
  class: "card-description"
}
const _hoisted_47 = { class: "card-type-badge" }
const _hoisted_48 = {
  key: 2,
  class: "bi bi-star-fill favorite-indicator"
}
const _hoisted_49 = {
  key: 0,
  class: "no-results"
}
const _hoisted_50 = ["data-bs-title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", {
      class: "list-page-sidebar book-contents-sidebar",
      "aria-label": $setup.label('sidebarNavigation', 'Navigation')
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString($setup.label("searchTitle", "Search")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-search" }, null, -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  ref: "searchInput",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: $setup.label('searchPlaceholder', 'Search in this book...')
                }, null, 8 /* PROPS */, _hoisted_9), [
                  [_vModelText, $setup.query]
                ])
              ])
            ])
          ])
        ]),
        ($props.typeOptions.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h2", _hoisted_11, _toDisplayString($setup.label("categoryTitle", "Category")), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_12, [
                _createVNode($setup["TypeFilterSelect"], {
                  options: $props.typeOptions,
                  "model-value": $setup.typeFilter,
                  "search-placeholder": $setup.label('searchTypes', 'Search types...'),
                  "onUpdate:modelValue": $setup.setTypeFilter
                }, null, 8 /* PROPS */, ["options", "model-value", "search-placeholder", "onUpdate:modelValue"])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h2", _hoisted_14, _toDisplayString($setup.label("viewTitle", "View")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["view-btn", { active: $setup.viewMode === 'list' }]),
              "data-bs-toggle": "tooltip",
              "data-bs-title": $setup.label('viewList', 'List view'),
              onClick: _cache[1] || (_cache[1] = $event => ($setup.setViewMode('list')))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "bi bi-list" }, null, -1 /* CACHED */)
            ]))], 10 /* CLASS, PROPS */, _hoisted_16),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["view-btn", { active: $setup.viewMode === 'cards' }]),
              "data-bs-toggle": "tooltip",
              "data-bs-title": $setup.label('viewCards', 'Card view'),
              onClick: _cache[2] || (_cache[2] = $event => ($setup.setViewMode('cards')))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1 /* CACHED */)
            ]))], 10 /* CLASS, PROPS */, _hoisted_17)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h2", _hoisted_19, _toDisplayString($setup.label("alphabetTitle", "A–Z")), 1 /* TEXT */),
          _createElementVNode("nav", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.letters, (letter) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: letter }, [
                ($setup.letterHasItems(letter))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `#${$setup.sectionId(letter)}`,
                      class: _normalizeClass(["alphabet-link", { current: $setup.currentLetter === letter }]),
                      onClick: $event => ($setup.jumpToLetter($event, letter))
                    }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_21))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(letter), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: _normalizeClass(["contents-list view-list", { active: $setup.viewMode === 'list' }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedGroups, ([letter, items]) => {
            return (_openBlock(), _createElementBlock("section", {
              id: `letter-${letter}`,
              key: `list-${letter}`,
              class: "letter-group",
              "data-letter": letter
            }, [
              _createElementVNode("h3", _hoisted_26, _toDisplayString(letter), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `list-item-${item.id}`,
                    class: "content-item"
                  }, [
                    _createElementVNode("a", {
                      href: item.url,
                      class: "item-link",
                      "data-turbo": "false",
                      "data-content-window-id": $props.openInWindow ? item.id : null,
                      "data-content-window-title": $props.openInWindow ? item.name : null,
                      onClick: $event => ($setup.openItem(item, $event))
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        (item.imageUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.imageUrl,
                              alt: item.name,
                              class: "type-icon",
                              loading: "lazy"
                            }, null, 8 /* PROPS */, _hoisted_30))
                          : (item.typeIconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: item.typeIconUrl,
                                alt: item.typeLabel,
                                class: "type-icon"
                              }, null, 8 /* PROPS */, _hoisted_31))
                            : (item.typeIconClass)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 2,
                                  class: _normalizeClass(item.typeIconClass)
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("h4", _hoisted_33, _toDisplayString(item.name), 1 /* TEXT */),
                        (item.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(item.description), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(item.typeLabel), 1 /* TEXT */)
                      ]),
                      (item.favorited)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_28)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 8 /* PROPS */, _hoisted_25))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["contents-list view-cards", { active: $setup.viewMode === 'cards' }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedGroups, ([letter, items]) => {
            return (_openBlock(), _createElementBlock("section", {
              id: `letter-${letter}-cards`,
              key: `cards-${letter}`,
              class: "letter-group",
              "data-letter": letter
            }, [
              _createElementVNode("h3", _hoisted_38, _toDisplayString(letter), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: `card-item-${item.id}`,
                    href: item.url,
                    class: "content-card card-link",
                    "data-turbo": "false",
                    "data-content-window-id": $props.openInWindow ? item.id : null,
                    "data-content-window-title": $props.openInWindow ? item.name : null,
                    onClick: $event => ($setup.openItem(item, $event))
                  }, [
                    (item.imageUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("img", {
                            src: item.imageUrl,
                            alt: item.name,
                            loading: "lazy"
                          }, null, 8 /* PROPS */, _hoisted_42)
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "card-icon",
                          style: _normalizeStyle({ background: item.gradient })
                        }, [
                          (item.typeIconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: item.typeIconUrl,
                                alt: item.typeLabel,
                                class: "type-icon",
                                width: "32",
                                height: "32"
                              }, null, 8 /* PROPS */, _hoisted_43))
                            : (item.typeIconClass)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  class: _normalizeClass(item.typeIconClass)
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                        ], 4 /* STYLE */)),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("h4", _hoisted_45, _toDisplayString(item.name), 1 /* TEXT */),
                      (item.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(item.description), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_47, _toDisplayString(item.typeLabel), 1 /* TEXT */)
                    ]),
                    (item.favorited)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_48))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_40))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 8 /* PROPS */, _hoisted_37))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */),
        ($setup.showNoResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-search" }, null, -1 /* CACHED */)),
              _createElementVNode("p", null, _toDisplayString($setup.label("noResults", "No results found")), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn-scroll-to-filters", { visible: $setup.showScrollToFilters }]),
      "data-bs-toggle": "tooltip",
      "data-bs-title": $setup.label('scrollToFilters', 'Jump to filters'),
      onClick: $setup.scrollToFiltersAndFocus
    }, [...(_cache[7] || (_cache[7] = [
      _createElementVNode("i", { class: "bi bi-funnel" }, null, -1 /* CACHED */)
    ]))], 10 /* CLASS, PROPS */, _hoisted_50)
  ]))
}